import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopBar } from './top-bar';
import { MenuComponent } from './menu';
import { Drawer } from 'primeng/drawer';
import { Button } from 'primeng/button';
import { LayoutService } from '../../services/LayoutService';
import { NgOptimizedImage } from '@angular/common';
import { AuthService } from '../../services/AuthService';

@Component({
  selector: 'app-layout',
  imports: [
    RouterOutlet,
    TopBar,
    MenuComponent,
    Drawer,
    Button,
    NgOptimizedImage
  ],
  template: `
    <div class="w-full h-full flex flex-col bg-surface-200 dark:bg-surface-800 layout-container">
      <app-top-bar/>
      <div class="flex flex-row grow">
        <div class="hidden lg:block w-[200px] min-w-[200px] h-full p-4 sidebar-container">
          <app-menu/>
        </div>
        <p-drawer
          [position]="auth.rtl() ? 'right' : 'left'"
          [visible]="layoutService.mobileMenuOpen()"
          (visibleChange)="layoutService.mobileMenuOpen.set($event)"
          [modal]="true"
          [closable]="true"
          [blockScroll]="true">
          <ng-template #headless>
            <div class="h-full flex flex-col relative">
              <p-button variant="text" severity="contrast" class="absolute top-2 start-2 z-50 w-10 h-10 p-0 flex items-center justify-center" (click)="layoutService.mobileMenuOpen.set(false)">
                <i class="pi pi-times" style="font-size: 1.5rem"></i>
              </p-button>
              <div class="flex-grow overflow-y-auto p-4 pt-12 flex flex-col gap-4">
                <div class="flex items-center justify-center">
                  <img ngSrc="/logo.svg" [height]="120" [width]="120" alt="logo" class="dark:hidden">
                  <img ngSrc="/logo.dark.svg" [height]="120" [width]="120" alt="logo" class="hidden dark:block">
                </div>
                <app-menu/>
              </div>
            </div>
          </ng-template>
        </p-drawer>
        <div class="grow">
          <div class="p-0 pt-1 sm:p-4 print:p-0">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  `
})
export class Layout {
  public layoutService = inject(LayoutService);
  public auth = inject(AuthService);
}
